import { render } from "./ModuleVariableListItem.vue?vue&type=template&id=052d623f&scoped=true"
import script from "./ModuleVariableListItem.vue?vue&type=script&lang=js"
export * from "./ModuleVariableListItem.vue?vue&type=script&lang=js"

import "./ModuleVariableListItem.vue?vue&type=style&index=0&id=052d623f&scoped=true&lang=css"
import "./ModuleVariableListItem.vue?vue&type=style&index=1&id=052d623f&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052d623f"]])

export default __exports__